import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function TicketFilled({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 16 16"
    >
      <Path
        d="M9.33398 4.00049H10.667V2.6665H15.333C15.7012 2.6665 16 2.96531 16 3.3335V5.99951C14.8956 5.99951 14.0003 6.89516 14 7.99951C14 9.10408 14.8954 9.99951 16 9.99951V12.6665C16 13.0347 15.7012 13.3335 15.333 13.3335H10.667V12.0005H9.33398V13.3335H0.666992C0.298802 13.3335 0 13.0347 0 12.6665V9.99951C1.10457 9.99951 2 9.10408 2 7.99951C1.99974 6.89516 1.10441 5.99951 0 5.99951V3.3335C0 2.96531 0.298802 2.6665 0.666992 2.6665H9.33398V4.00049ZM9.33398 9.3335H10.667V6.6665H9.33398V9.3335Z"
        fill={iconColor}
      />
    </Svg>
  );
}
